import React from 'react';
import moment from 'moment';
import Loading from '../../components/Loading/Loading';
import HeaderComponent from '../../components/Header';
import { appointmentActions, counsellorActions, authActions, alertActions } from '../../store/actions';
import { connect } from 'react-redux';
import Footer from '../../components/Footer/footer';
import Swal from 'sweetalert2';
import { history } from '../../helpers';
import '../../static/css/styles.css';
import { constants } from '../../Constants';
import { createApptConst } from '../../helpers/ConstantID';
import Select from 'react-select';

const selectStylesUser = {
	option: (provided, state) => ({
		...provided,
		borderBottom: "1px ",
		color: state.isSelected ? "black" : "",
		fontSize: 16,
		backgroundColor: state.isSelected ? "#eee" : "",
		textAlign: "left",
		cursor: "pointer"
	}),
	container: base => ({
		...base,
		minWidth: 400
	}),
	control: base => ({
		...base,
		height: 45,
		fontSize: 15,
		borderRadius: "4px",
		width: "100%",
		textAlign: "left",
		cursor: "pointer"
	}),
	valueContainer: base => ({
		...base,
		padding: 0,
		paddingLeft: 2
	})
};
const selectStyles = {
	option: (provided, state) => ({
		...provided,
		borderBottom: "1px ",
		color: state.isSelected ? "black" : state.isDisabled ? 'grey' : "black",
		fontSize: 16,
		backgroundColor: state.isSelected ? "#eee" : "",
		textAlign: "left",
		cursor: state.isDisabled ? 'auto' : "pointer"
	}),
	container: base => ({
		...base,
		width: "auto"
	}),
	control: base => ({
		...base,
		height: 45,
		fontSize: 15,
		borderRadius: "4px",
		width: "100%",
		textAlign: "left",
		cursor: "pointer"
	}),
	valueContainer: base => ({
		...base,
		padding: 0,
		paddingLeft: 2
	})
};

const optionsMonths = [
	{ value: '0', label: 'January' },
	{ value: '1', label: 'February' },
	{ value: '2', label: 'March' },
	{ value: '3', label: 'April' },
	{ value: '4', label: 'May' },
	{ value: '5', label: 'June' },
	{ value: '6', label: 'July' },
	{ value: '7', label: 'August' },
	{ value: '8', label: 'September' },
	{ value: '9', label: 'October' },
	{ value: '10', label: 'November' },
	{ value: '11', label: 'December' },
]

const optionsYears = [
	{ value: new Date().getFullYear(), label: new Date().getFullYear() },
	{ value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
	{ value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
	{ value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
	{ value: new Date().getFullYear() + 4, label: new Date().getFullYear() + 4 },
	{ value: new Date().getFullYear() + 5, label: new Date().getFullYear() + 5 },
]

const optionsTime = [
	{ value: '00:00:00', label: '12:00 AM' },
	{ value: '01:00:00', label: '1:00 AM' },
	{ value: '02:00:00', label: '2:00 AM' },
	{ value: '03:00:00', label: '3:00 AM' },
	{ value: '04:00:00', label: '4:00 AM' },
	{ value: '05:00:00', label: '5:00 AM' },
	{ value: '06:00:00', label: '6:00 AM' },
	{ value: '07:00:00', label: '7:00 AM' },
	{ value: '08:00:00', label: '8:00 AM' },
	{ value: '09:00:00', label: '9:00 AM' },
	{ value: '10:00:00', label: '10:00 AM' },
	{ value: '11:00:00', label: '11:00 AM' },
	{ value: '12:00:00', label: '12:00 PM' },
	{ value: '13:00:00', label: '1:00 PM' },
	{ value: '14:00:00', label: '2:00 PM' },
	{ value: '15:00:00', label: '3:00 PM' },
	{ value: '16:00:00', label: '4:00 PM' },
	{ value: '17:00:00', label: '5:00 PM' },
	{ value: '18:00:00', label: '6:00 PM' },
	{ value: '19:00:00', label: '7:00 PM' },
	{ value: '20:00:00', label: '8:00 PM' },
	{ value: '21:00:00', label: '9:00 PM' },
	{ value: '22:00:00', label: '10:00 PM' },
	{ value: '23:00:00', label: '11:00 PM' },
]

class CounsellorAppointments extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownValue: '0',
			selectedDate: '',
			normalState: true,
			searchedState: false,
			slot_id: '',
			session: [],
			searchedTimeSlots: [],
			days_created: [],
			counsellor_id: '',
			toggleChecked: null,
			role: sessionStorage.getItem('role'),
			appointments: [],
			appointmentsChanged: false,
			counsellorStatus: null,
			counsellorPopup: false,
			allowedPermissions: false,
			selected_day: 0,
			selected_month: 0,
			selected_year: 0,
			selected_patient: '',
			selected_time: '',
			patients: [],
			timeZone: '',
			option_time: optionsTime,
			option_years: optionsYears,
			option_month: optionsMonths,
			isDisabledSubmitButton: true

		};
	}

	componentDidMount() {
		const dt = new Date();
		this.setState({
			selected_day: dt.getDate(),
			selected_month: dt.getMonth(),
			selected_year: dt.getFullYear(),
		});

		this.cancelAppointment = this.cancelAppointment.bind(this);
		this.callAppointmentApiCall = this.callAppointmentApiCall.bind(this);
		this.onChangeDay = this.onChangeDay.bind(this);
		this.onChangeMonth = this.onChangeMonth.bind(this);
		this.onChangeYear = this.onChangeYear.bind(this);
		this.onChangeUser = this.onChangeUser.bind(this);
		this.onChangeTime = this.onChangeTime.bind(this);
		this.setTimeZone = this.setTimeZone.bind(this);
		this.submitHandler = this.submitHandler.bind(this);
	}

	componentWillMount() {
		this.props.getPatientsList();
		this.props.getUserData();
		this.setTimeZone();
		this.createDates();
		if (this.props.user !== undefined && this.props.user !== null) {
			if (this.props.user.role === 1) {
				history.replace('/home');
			}
		}

	}

	setTimeZone = () => {
		const dt = new Date();
		if (dt.toString().indexOf('(') > -1) {
			const timezone = dt.toString().split('(')[1].split(')')[0];
			this.setState({ timeZone: timezone });
		}
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps.patients && nextProps.patients !== this.state.patients) {
			this.setState({
				patients: nextProps.patients,
			});
		}
		if (nextProps.loading && nextProps.loading !== this.state.isLoading) {
			this.setIsLoading(nextProps.loading);
		}
	}

	callAppointmentApiCall = () => {
		const current_time = moment(new Date()).utc().format();
		const { selected_day, selected_month, selected_year, selected_time, selected_patient } = this.state;

		const date = `${parseInt(selected_year.value)}-${parseInt(selected_month.value) + 1}-${parseInt(selected_day.value)} ${selected_time.value}`;

		const slotTime = moment(date, 'YYYY-MM-DD hh:mm:ss').utc().format();

		if (slotTime === '' || selected_patient.value === '') {
			const message = constants.FILL_ALL_FIELDS_MSG;
			this.props.alertError(message);
		} else if (selected_patient.value === '') {
			const message = constants.SELECT_USER_ERROR_MSG;
			this.props.alertError(message);
		} else if (slotTime !== '' && selected_patient.value !== '') {
			this.setIsLoading(true);
			this.props.createAppointmentV2(current_time, slotTime, selected_patient.value);
			this.props.clearAlertActions();
		}
	};

	setIsLoading = (loading) => {
		this.setState({
			isLoading: loading,
		});
	};

	cancelAppointment = () => {
		Swal.fire({
			title: constants.DELETE_CONFORM_HEADER_TXT,
			text: constants.LEAVE_SCREEN_MSG,
			type: 'question',
			reverseButtons: true,
			showCancelButton: true,
			confirmButtonColor: '#36A692',
			cancelButtonColor: '#d33',
			cancelButtonText: 'No',
			confirmButtonText: 'Yes',
		}).then((result) => {
			if (result.value) {
				this.props.history.goBack();
			} else {
			}
		});
	}

	createDates = () => {
		const { selected_month, selected_year } = this.state;
		const maxDays = new Date(selected_year, selected_month, 0).getDate();
		let result = [];
		for (let i = 1; i <= maxDays; i++) {
			result.push({
				label: i,
				value: i
			});
		}
		this.setState({
			days_created: result
		})
		return result;
	};

	onChangeYear = (selectedYear) => {
		this.setState({ selected_year: selectedYear }, () => { this.submitHandler() });
		let months = this.state.option_month;
		if (selectedYear.value == new Date().getFullYear()) {
			const currentMonth = new Date().getMonth();
			for (let i = 0; i < currentMonth; i++) { // disable months before current month
				months[i].isDisabled = true
			}
		} else {
			for (let i = 0; i < months.length; i++) {
				months[i].isDisabled = false
			}
		}
		this.setState({ option_month: months, selected_month: 0, selected_day: 0, selected_time: '' })
	};

	onChangeDay = (selectedDay) => {
		this.setState({ selected_day: selectedDay }, () => { this.submitHandler() });
		let time = this.state.option_time;
		if (selectedDay.value == new Date().getDate()) {
			const currentTime = new Date().getHours();
			for (let i = 0; i < currentTime + 1; i++) { // disable hours before current hour
				time[i].isDisabled = true
			}
		} else {
			for (let i = 0; i < time.length; i++) {
				time[i].isDisabled = false
			}
		}
		this.setState({ option_time: time, selected_time: '' })
	};

	onChangeMonth = (selectedMonth) => {
		this.setState({ selected_month: selectedMonth }, () => { this.submitHandler() });
		let createdDays = this.state.days_created;
		if (selectedMonth.value == new Date().getMonth()) {
			const currentDay = new Date().getDate();
			for (let i = 0; i < currentDay - 1; i++) { // disable dates before current date
				createdDays[i].isDisabled = true;
			}
		} else {
			for (let i = 0; i < createdDays.length; i++) {
				createdDays[i].isDisabled = false;
			}
		}
		this.setState({
			days_created: createdDays, selected_day: 0, selected_time: ''
		})
	};
	onChangeUser = (selectedUser) => {
		this.setState(this.setState({ selected_patient: selectedUser }, () => { this.submitHandler() }))
	};
	onChangeTime = (selectedTime) => {
		this.setState({ selected_time: selectedTime }, () => { this.submitHandler() });
	};


	submitHandler = () => {
		if (this.state.selected_year.value && this.state.selected_month.value && this.state.selected_day.value && this.state.selected_time.value && this.state.selected_patient.value) {
			this.setState({ isDisabledSubmitButton: false })
		}else{
			this.setState({ isDisabledSubmitButton: true })
		}
	}
	handleSessionCapClick = (id) => {
		this.props.history.push(`/patient-details/${id}`);
	};

	render() {
		const { loading, alert } = this.props;
		const { selected_month, selected_year, patients, isLoading, timeZone, days_created } = this.state;
		const maxDays = new Date(selected_year, parseInt(selected_month) + 1, 0).getDate();

		let createDates = [];
		for (let i = 1; i <= maxDays; i++) {
			createDates.push({
				label: i,
				value: i
			})
		}

		let UserOptions = [];
		if (patients && patients.length > 0) {
			UserOptions = patients.map((p, i) => {
				const remainingSessionCap = p.patient_total_session_cap - p.patient_consumed_session_cap;
				return {
					key: i,
					name: p.patient_name,
					value: p.patient_id,
					remainingSessionCap: remainingSessionCap,
					isAllowed: p.patient_is_session_cap_allowed
				};
			});
		} else {
			UserOptions.push({
				label: constants.NO_PATIENTS_MSG,
				value: constants.NO_PATIENTS_MSG
			});
		}

		if (loading) {
			return <Loading />;
		} else {
			return (
				<div className="sh-layout">
					<HeaderComponent />

					<div className="sh-create-apointment-comp sh-gnrl-width">
						{/* Welcome Note */}
						<div className="sh-gnrl-welcome-note">
							<h2 className="sh-gnrl-welcome" id="">
								{constants.CREATE_APPOINTMENT_TXT}
							</h2>
						</div>

						<div className="sh-gnrl-apointment-cont">
							<div className="inner">
								<div className="sh-gnrl-form-group">
									<label htmlFor="sh_day_selector">{constants.SELECT_DAY_TXT}</label>
									<div className="day-selector" id="sh_day_selector">
										<div className="sh_selector_new">
											<Select
												id={createApptConst.sh_cl_app_year}
												styles={selectStyles}
												options={optionsYears}
												value={this.state.selected_year}
												onChange={this.onChangeYear}
												placeholder="Year"
											/>
										</div>
										<div className="sh_selector_new">
											<Select
												id={createApptConst.sh_cl_app_month}
												styles={selectStyles}
												options={optionsMonths}
												value={this.state.selected_month}
												onChange={this.onChangeMonth}
												placeholder="Month"
												isDisabled={this.state.selected_year.value ? false : true}
											/>
										</div>
										<div className="sh_selector_new">
											<Select
												id={createApptConst.sh_cl_app_day}
												styles={selectStyles}
												options={days_created}
												value={this.state.selected_day}
												onChange={this.onChangeDay}
												placeholder="Day"
												isDisabled={this.state.selected_month.value ? false : true}
											/>
										</div>
									</div>
								</div>
								<div className="sh-gnrl-form-group">
									<label htmlFor="sh_time_selector">{constants.SELECT_TIME}</label>
									<div className="sh_selector_new">
										<Select
											id="sh_time_selector"
											styles={selectStyles}
											options={optionsTime}
											value={this.state.selected_time}
											onChange={this.onChangeTime}
											placeholder="Time"
											isDisabled={this.state.selected_day.value ? false : true}
										/>
									</div>
									<p className="sh-create-appointment-timezone">{timeZone}</p>
								</div>

								<div className="sh-gnrl-form-group">
									<label htmlFor="sh_user_selector">{constants.SELECT_USER_TXT}</label>
									<div className="sh_selector_new">
										<Select
											id="sh_user_selector"
											styles={selectStylesUser}
											options={UserOptions}
											value={this.state.selected_patient}
											onChange={this.onChangeUser}
											placeholder="Select User"
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.value}
											formatOptionLabel={(option, { context }) => {
												if (context === 'menu') {
													if (option.value === constants.NO_PATIENTS_MSG) {
														return <span>{option.label}</span>;
													}
													return (
														<div className="d-flex justify-content-between">
															<span>{option.name}</span>
															<span
																onClick={() => option.isAllowed && option.remainingSessionCap === 0 && this.handleSessionCapClick(option.value)}
																style={{
																	cursor: option.isAllowed && option.remainingSessionCap === 0 ? 'pointer' : 'default',
																	textDecoration: option.isAllowed && option.remainingSessionCap === 0 ? 'underline' : 'none'
																}}
															>
																{option.isAllowed
																	? (option.remainingSessionCap > 0
																		? `${option.remainingSessionCap} session left`
																		: '0')
																	: <span>No limits</span>
																}
															</span>
														</div>
													);
												}
												return option.name;
											}}
										/>
									</div>
								</div>

								{alert && alert.message ? (
									<div className="sh-error-text" id="errorMessage">
										{alert.message}
									</div>
								) : (
									''
								)}

							</div>
						</div>

						<div className="sh-btn-box">
							<button className="sh-gnrl-btn sh-gnrl-cancel-btn" onClick={this.cancelAppointment}
								id='btnCancel'>
								{constants.CANCEL_TXT}
							</button>
							<button className="sh-gnrl-btn sh-gnrl-sumit-btn" disabled={this.state.isDisabledSubmitButton} onClick={this.callAppointmentApiCall}
								id='btnSubmit'>
								{constants.SUBMIT_TXT}
							</button>
						</div>



					</div>

					<Footer />
				</div>
			);
		}
	}
}

function mapStateToProps(state) {
	const { patients, loading } = state.appointments;
	const { whitelabel } = state.whitelabel;
	const { alert } = state;
	return {
		alert,
		patients,
		whitelabel,
		loading,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		getPatientsList: () => {
			dispatch(appointmentActions.getPatientsList());
		},
		getUserData: () => {
			dispatch(authActions.getUserData());
		},
		createAppointmentV2: (current_time, slotTime, patientId) => {
			dispatch(appointmentActions.createAppointmentV2(current_time, slotTime, patientId));
		},
		clearAlertActions: () => {
			dispatch(alertActions.clear());
		},
		alertError: (message) => {
			dispatch(alertActions.error(message));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CounsellorAppointments);



// WEBPACK FOOTER //
// ./src/screens/CounsellorAppointment/index.js